/** Logger which outputs to the browser console */
export class ConsoleLogger {
  log() {}
  warn() {}
  error() {}
  constructor(level) {
    if (level === "high") {
      this.error = console.error.bind(console);
      this.warn = console.warn.bind(console);
      this.log = console.log.bind(console);
    }
  }
}

export const logger = new ConsoleLogger(process.env.REACT_APP_LOG_LEVEL);
